import React from 'react';
import { connect } from 'react-redux';
import lodash from 'lodash';

import { Button, BUTTON } from 'components/common/Button/Button';
const { SIZE, COLOR, BGCOLOR } = BUTTON;
import styles from './ExternalUserSearch.scss';
import Modal from 'components/common/Modal/Modal';
import Input from 'components/common/Input/FormInput';

import { loadExternalUser } from 'binder/actions/externalUsers';

const DESCRIPTION = 'Please provide the email address for the person you wish to add.';

// RFC 5322 (mostly) compliant "practical" regex for practical email validation
// https://www.regular-expressions.info/email.html
const EMAIL_ADDRESS_PATTERN = /^[a-z0-9!#$%&'*+/=?^_‘{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_‘{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

class ExternalUserSearch extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            email: null,
        };

        this.updateEmailState = this.updateEmailState.bind(this);
        this.checkForExistingUser = this.checkForExistingUser.bind(this);
        this.close = this.close.bind(this);
        this.resetState = this.resetState.bind(this);
        this.missingRequiredFields = this.missingRequiredFields.bind(this);
        this.emailMatchesExpectedPattern = this.emailMatchesExpectedPattern.bind(this);
    }

    componentDidMount() {
        document.body.style['overflow-y'] = 'hidden';
    }

    componentWillUnmount() {
        document.body.style['overflow-y'] = 'visible';
    }

    componentDidUpdate(prevProps) {
        if (prevProps.existingUser && !this.props.existingUser) {
            this.resetState();
        }
    }

    close() {
        this.resetState();
        this.props.onClose();
    }

    resetState() {
        this.setState({ email: null });
    }

    updateEmailState(e) {
        this.setState({ email: e.target.value.toLowerCase() });
    }

    checkForExistingUser() {
        if (this.allInputFieldsComplete()) {
            this.props.loadExternalUser(this.state.email);
        }
    }

    allInputFieldsComplete() {
        return !this.missingRequiredFields() && this.emailMatchesExpectedPattern();
    }

    emailMatchesExpectedPattern() {
        return EMAIL_ADDRESS_PATTERN.test(this.state.email);
    }

    missingRequiredFields() {
        return !this.state.email;
    }

    renderActionButtons() {
        return (
            <div name="add-external-user-action-buttons" className={styles.actionButtons}>
                <Button
                    text={'Close'}
                    type={SIZE.PRIMARY}
                    color={COLOR.GREY}
                    bgcolor={BGCOLOR.WHITE}
                    onClick={this.close}
                    data-cy="ExternalUserSearch-close"
                />

                <Button
                    text={'Continue'}
                    type={SIZE.PRIMARY}
                    color={COLOR.WHITE}
                    bgcolor={this.allInputFieldsComplete() ? BGCOLOR.ORANGE : BGCOLOR.LIGHTGREY}
                    disabled={!this.allInputFieldsComplete()}
                    onClick={this.checkForExistingUser}
                    data-cy="ExternalUserSearch-Continue"
                />
            </div>
        );
    }

    render() {
        if (!this.props.open || this.props.existingUser) {
            return null;
        }

        return (
            <Modal
                title="Add External User"
                open={this.props.open}
                onClose={this.close}
                data-cy="ExternalUserSearch-AddExternalUser"
            >
                <p className={styles.descriptionText}>{DESCRIPTION}</p>
                <Input
                    title={'Email Address'}
                    value={this.state.email}
                    placeholder={'email@example.com'}
                    required={true}
                    isValid={this.emailMatchesExpectedPattern}
                    errorText={'Please fill in a valid email address'}
                    onBlur={this.updateEmailState}
                    onChange={this.updateEmailState}
                    autoFocus={true}
                    onClick={this.checkForExistingUser}
                    data-cy="ExternalUserSearch-Email"
                />

                { this.renderActionButtons() }
            </Modal>
        );
    }
}

export default connect((state, props) => {
    const existingUser =  lodash.get(state, 'existingExternalUser', null);

    return {
        existingUser,
    };
}, {
    loadExternalUser,
})(ExternalUserSearch);
